import deburr from 'lodash/deburr';
import escapeRegExp from 'lodash/escapeRegExp';
import memoize from 'lodash/memoize';
import get from 'lodash/get';
import round from 'lodash/round';

// import { deburr, escapeRegExp, get, memoize, round } from 'lodash'
const normalize = (text)=>deburr(text).replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
const tokenize = (searchText)=>normalize(escapeRegExp(searchText)).match(RegExp("[\\p{L}\\d]+", "gimu")) || [];
const convertToSearchableStrings = memoize((elements, searchableKeys)=>{
    if (!elements || elements.length === 0 || !searchableKeys || searchableKeys.length === 0) {
        return [];
    }
    const arraySelectorRegex = /\[(.*)]/;
    return elements.map((element)=>searchableKeys.map((key)=>{
            const arraySelector = get(arraySelectorRegex.exec(key), '1');
            const value = get(element, key.replace(arraySelectorRegex, ''));
            if (value === null || value === undefined || typeof value === 'function') {
                return '';
            }
            if (arraySelector) {
                return value.map((x)=>get(x, arraySelector));
            }
            if (Array.isArray(value) || typeof value === 'object') {
                return JSON.stringify(value);
            }
            return value;
        }).reduce((a, b)=>a + b, '')).map((x)=>normalize(x));
});
const indexDocuments = convertToSearchableStrings;
const getScore = (matchesAllSearchWords, searchWords, searchableDataString)=>{
    if (!matchesAllSearchWords) {
        return 0;
    }
    const searchableDataStringWithoutNonWordCharacters = searchableDataString.replace(RegExp("[^\\p{L}\\d]+", "gimu"), '');
    const remainingTextAfterRemovingSearchWords = searchWords.sort((a, b)=>b.length - a.length).reduce((remainingText, searchWord)=>remainingText.replace(new RegExp(searchWord, 'gm'), ''), searchableDataStringWithoutNonWordCharacters);
    return round(1 - remainingTextAfterRemovingSearchWords.length / searchableDataStringWithoutNonWordCharacters.length, 4);
};
function search(elements, searchableKeys, searchText, options) {
    const searchWords = tokenize(searchText);
    const searchableDataStrings = convertToSearchableStrings(elements, searchableKeys);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return searchableDataStrings.reduce((accumulator, x, i)=>{
        var _options;
        const matchesAllSearchWords = searchWords.every((searchWord)=>x.includes(searchWord));
        if ((_options = options) == null ? void 0 : _options.withScore) {
            const score = getScore(matchesAllSearchWords, searchWords, x);
            accumulator.push({
                element: elements[i],
                score
            });
            return accumulator;
        }
        if (matchesAllSearchWords) {
            accumulator.push(elements[i]);
        }
        return accumulator;
    }, []);
}

export { convertToSearchableStrings, getScore, indexDocuments, normalize, search, tokenize };
